import { render, staticRenderFns } from "./HotelRoomDetails.vue?vue&type=template&id=f9b3b554"
import script from "./HotelRoomDetails.vue?vue&type=script&lang=js"
export * from "./HotelRoomDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports